let hasConsole = true;
let _console = window.console;
let getProto = Object.getPrototypeOf;
let $types = ["Boolean", "Number", "String", "Function", "Array", "Date", "RegExp", "Object", "Error", "Symbol"];
let class2type = {};
let hasOwn = class2type.hasOwnProperty;
let fnToString = hasOwn.toString;
let ObjectFunctionString = fnToString.call(Object);
let toString = class2type.toString;
let hasOwnProperty = Object.prototype.hasOwnProperty;
let uuidCharts = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");

$types.forEach(elem => {
    class2type["[object " + elem + "]"] = elem.toLowerCase();
});

export default {
    /**
     * 组件内手动渲染属性样式到页面的head中
     * @param {*} attrArray 样式属性对象，必须是数组格式
     * @param {*} moduleObject 组件对象，不能为空
     * @param {*} otherObject 能在使用条件或者样式中使用的表达式对象
     * @returns 返回渲染的数量
     */
    renderAttrStyleToPage: function (attrArray, moduleObject, otherObject) {
        if (!moduleObject || IDM.type(moduleObject) != "object" || (IDM.type(moduleObject) == "object" && Object.keys(moduleObject).length == 0)) {
            return "组件对象参数不能为空";
        }
        if (IDM.type(attrArray) === "array") {
            let paramCom = {
                moduleObject,
            };
            if (otherObject && IDM.type(otherObject) == "object") {
                Object.assign(paramCom, otherObject);
            }
            let renderCount = 0;
            for (let index = 0; index < attrArray.length; index++) {
                const item = attrArray[index];
                if (
                    item.styleUUID &&
                    item.styleType &&
                    item.cssCode &&
                    // item.idmCoreLoad !== true &&
                    IDM.type(item.cssCode) === "string"
                ) {
                    //进行表达式转换
                    if (
                        !item.styleCondition ||
                        (item.styleCondition && IDM.getExpressData(item.styleCondition, paramCom))
                    ) {
                        renderCount++;
                        let newUUID = item.styleUUID+"_"+item.styleRenderUUID?IDM.getExpressData(item.styleRenderUUID, paramCom, "", false):IDM.uuid();
                        IDM.setStyleHtmlToPageHead(
                            newUUID,
                            IDM.getExpressData(item.cssCode, paramCom, "", false)
                        );
                    }
                }
            }
            return renderCount;
        } else {
            return false;
        }
    },
    /**
     * 获取属性的最终结果值，优先去获取指定属性的变量绑定的执行结果，如果表达式没有则返回属性设置的结果
     * @param {*} _this 当前组件的this对象
     * @param {*} propData 当前组件的所有属性数据
     * @param {*} attrName 要获取的属性名称
     * @param {*} moduleObject 当前组件的对象
     * @param {*} extendPrefixName 当前属性的扩展前缀名称
     * @param {*} extendData 表达式绑定中提供的扩展数据对象
     */
    getAttrVarBindResultData:function(_this,propData,attrName,moduleObject,extendPrefixName,extendData){
        const afterStr = "_idmVarBind";
        if (propData.hasOwnProperty.call(propData, attrName+afterStr)) {
            const element = propData[attrName+afterStr];
            if (IDM.isUnDef(element)||(element&&!element.content)) {
                //为空直接返回属性
                return propData[attrName]
            }
            //不为空
            try {
                //IDM.express.eval("function(ctx){var aaa =abcdd(123)+ctx.ddd;return aaa}(@[abd])",{abd:{ddd:"abcdef"}})
                if(element.js){
                    //是js函数来执行
                    return IDM.express.eval("function(_this,moduleObject,"+extendPrefixName+"){"+element.content+"}(@[_this],@[moduleObject],@["+extendPrefixName+"])",{
                        _this,
                        moduleObject,
                        [extendPrefixName]:extendData
                    })
                }
                //表达式执行
                return IDM.getExpressData(element.content,{
                    _this,
                    moduleObject,
                    [extendPrefixName]:extendData
                })
            } catch (error) {
                return propData[attrName]
            }
        }
        return propData[attrName]
    },
    /**
     * 通用的获取表达式匹配后的结果
     * 例1：IDM.getExpressData("data.dataFieldName",{data:{dataFieldName:"1234"}})  // => 1234
     * 例2：IDM.getExpressData("_idm_[0].data.dataFieldName",[{data:{dataFieldName:"1234"}}])  // => 1234
     * 例3：IDM.getExpressData("_idm_","这里是字符串1234")  // => 这里是字符串1234
     * 例4：IDM.getExpressData("mydata[0].data.dataFieldName",[{data:{dataFieldName:"1234"}}],"mydata")  // => 1234
     * @param {*} expressStr 表达式字符串，不包含@[]
     * @param {*} objectData 表达式所使用的对象数据，如果为object类型则可直接使用，如果为数组或者其他类型则会默认给添加到 _idm_ 字段中，因此表达式需要带上 _idm_.dataFieldName 这样
     * @param {*} defaultPrefix 为数组或者其他类型的默认字段名称，默认为 _idm_ ，如果需要定义其他可以传此参数
     * @param {*} addAt 是否自动追加艾特@符号 '@[]',默认为追加，为false则不追加
     * @returns 
     */
    getExpressData: function (expressStr, objectData, defaultPrefix,addAt) {
        //给defaultValue设置dataFiled的值
        var resultData;
        if (expressStr) {
            var dataObject = { IDM: window.IDM, window };
            if (IDM.type(objectData) == "object") {
                //直接合并
                Object.assign(dataObject, objectData);
            } else {
                dataObject[defaultPrefix || "_idm_"] = objectData;
            }
            resultData = window.IDM.express.replace(
                addAt===false?expressStr:"@[" + expressStr + "]",
                dataObject
            );
        }
        return resultData;
    },
    /**
     * 更新vue的data
     * @param {*} _this vue对象
     * @param {*} dataName data的名称
     * @param {*} attrData 整个要更新的数据
     * @returns 
     */
    refreshVueData:function(_this,dataName,attrData){
        // debugger
        if(!_this||!dataName||!attrData||typeof attrData!="object"){
            return;
        }
        Object.keys(attrData).forEach(key=>{
            _this.$set(_this[dataName],key,attrData[key])
        })
        _this.$forceUpdate();
    },
    /**
     * 对比被修改的值，返回被修改的旧对象，新对象不为空也
     * @param {*} object 
     * @param {*} base 
     * @returns 
     */
    difference:function(object, base) {
        object = object ||{};
        base = base ||{};
        function changes(object, base) {
            return _.transform(object, function(result, value, key) {
                if (!_.isEqual(value, base[key])) {
                    result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
                }
            });
        }
        return changes(object, base);
    },
    /**
     * 
     * @param  {...any} args 参数集
     * @returns 结果集数组
     * @example In vue instance -> IDM.invokeCustomFunctions.apply(this, [this.propData.customFunction, {}])
     */
    invokeCustomFunctions(...args) {
        if(args.length === 0) return console.error('IDM.invokeCustomFunctions need functions list')
        const functions = args[0], customOptions = args[1] || {}
        if(!functions || functions.length === 0) return []
        const results = []
        functions.forEach(func => {
            const result = window[func.name].call(this, {
                pageId: window.IDM.broadcast && window.IDM.broadcast.pageModule ? window.IDM.broadcast.pageModule.id : "",
                _this: this,
                ...IDM.url.queryObject(),
                ...(func.param || {}),
                ...customOptions
            })
            results.push(result)
        })
        return results
    },
    /**
     * 将样式html字符串添加到head标签
     * @param {*} selector
     * @param {*} styleHtml
     */
    setStyleHtmlToPageHead: function(selector, styleHtml){
      const oldStyleElement = this.findStyleElement(selector)
      if(oldStyleElement){
        if(oldStyleElement.innerHTML !== styleHtml){
            oldStyleElement.innerHTML = styleHtml
        }
        return
      }
      const newStyleElement=document.createElement("style");
      newStyleElement.setAttribute("from",selector);
      newStyleElement.innerHTML=styleHtml
      document.getElementsByTagName('head')[0].appendChild(newStyleElement)
    },
    /**
     * 把object样式转换为style标签样式并添加到head的标签中
     * @param {*} selector
     * @param {*} object
     * @param {*} addSelector 是否添加前缀，传false就不加，不传则默认加
     */
    setStyleToPageHead: function(selector, object,addSelector){
      const oldStyleElement = this.findStyleElement(selector)
      let newStyleStr = "";
      if(Object.keys(object).length==0){
        return;
      }
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          const element = object[key];
          newStyleStr+=`${key}:${element};`
        }
      }
      newStyleStr = `${selector.indexOf(".")==0||selector.indexOf("@font-face")==0||addSelector===false?"":"#"}${selector}{${newStyleStr}}`;
      if(oldStyleElement){
        if(oldStyleElement.innerHTML !== newStyleStr){
            oldStyleElement.innerHTML = newStyleStr
        }
        return
      }
      const newStyleElement=document.createElement("style");
      newStyleElement.setAttribute("from",selector);
      newStyleElement.innerHTML=newStyleStr
      document.getElementsByTagName('head')[0].appendChild(newStyleElement)
    },
    /**
     * 根据from找style元素
     */
    findStyleElement(selector) {
        const styles = document.getElementsByTagName('style')
        const styleElement = Array.prototype.find.call(styles, el => el.getAttribute("from") === selector)
        if(styleElement) return styleElement
        return false
    },
    /**
     * 获取浏览器可视区域宽高方法
     * @returns {Object}
     */
    getClientWH:function() {
        var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        return {width:w,height:h};
    },
    //获取唯一标识
    uuid: function(len, radix) {
        var chars = uuidCharts,
            uuid = [],
            i;
        radix = radix || chars.length;
        len = len || 16;
        if (len) {
            // Compact form
            for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
        } else {
            // rfc4122, version 4 form
            var r;

            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = "";
            uuid[14] = "4";

            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | (Math.random() * 16);
                    uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
                }
            }
        }

        return uuid.join("");
    },
    UUID: function() {
        return this.uuid();
    },
    //验证是否为一个空对象
    isEmptyObject: function(obj) {
        var name;
        for (name in obj) {
            return false;
        }
        return true;
    },
    //验证是否不为undefind或者null
    isDef: function(obj) {
        return obj !== undefined && obj != null;
    },
    //验证是否为undefind或者null
    isUnDef: function(obj) {
        return obj === undefined || obj === null;
    },
    //获取对象类型
    type: function(obj) {
        if (obj == null) {
            return obj + "";
        }
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[Object.prototype.toString.call(obj)] || "object" : typeof obj;
    },
    /**
     * 验证类型是否为函数
     * @param {*} fn 
     * @returns 
     */
    isFunction:function(fn) {
        return this.type(fn) == "function";
    },
    hasOwn:function(obj, key) {
        return hasOwnProperty.call(obj, key);
    },
    /**
     * 验证是否是一个纯粹的对象
     * @param {*} obj 
     * @returns 
     */
    isPlainObject:function(obj) {
        var proto, Ctor;
        if (!obj || Object.prototype.toString.call(obj) !== "[object Object]") {
            return false;
        }

        proto = Object.getPrototypeOf(obj);
        if (!proto) {
            return true;
        }
        Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
        return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
    },
    //代理console.log
    log: function() {
        if (hasConsole) {
            Function.apply.call(_console.log, _console, arguments);
        }
    },
    //代理console.time
    time: function() {
        if (hasConsole) {
            var method = _console.time;
            Function.apply.call(method, _console, arguments);
        }
    },
    //代理console.timeEnd
    timeEnd: function() {
        if (hasConsole) {
            var method = _console.timeEnd;
            Function.apply.call(method, _console, arguments);
        }
    },
    //代理console.warn
    warn: function() {
        if (hasConsole) {
            var method = _console.warn || _console.log;
            Function.apply.call(method, _console, arguments);
        }
    },
    //代理console.error
    error: function() {
        if (hasConsole) {
            var method = _console.error || _console.log;
            Function.apply.call(method, _console, arguments);
        }
    },
    /**
     * 类似jQuery.extend方法，可用于浅拷贝，深拷贝
     * @returns 
     */
    mix:function() {
        var options,
            name,
            src,
            copy,
            copyIsArray,
            clone,
            target = arguments[0] || {},
            i = 1,
            length = arguments.length,
            deep = false;

        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;

            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }

        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !this.isFunction(target)) {
            target = {};
        }

        if (i === length) {
            target = this;
            i--;
        }

        for (; i < length; i++) {
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) {
                // Extend the base object
                for (name in options) {
                    copy = options[name];

                    // Prevent Object.prototype pollution
                    // Prevent never-ending loop
                    if (name === "__proto__" || target === copy) {
                        continue;
                    }

                    // Recurse if we're merging plain objects or arrays
                    if (deep && copy && (this.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                        src = target[name];

                        // Ensure proper type for the source value
                        if (copyIsArray && !Array.isArray(src)) {
                            clone = [];
                        } else if (!copyIsArray && !this.isPlainObject(src)) {
                            clone = {};
                        } else {
                            clone = src;
                        }
                        copyIsArray = false;

                        // Never move original objects, clone them
                        target[name] = this.mix(deep, clone, copy);

                        // Don't bring in undefined values
                    } else if (copy !== undefined) {
                        target[name] = copy;
                    }
                }
            }
        }

        // Return the modified object
        return target;
    },
    dateFormat:function (timestamp, formats) {
        // formats格式包括
        // 1. Y-m-d
        // 2. Y-m-d H:i:s
        // 3. Y年m月d日
        // 4. Y年m月d日 H时i分
        formats = formats || 'Y-m-d';
    
        var zero = function (value) {
            if (value < 10) {
                return '0' + value;
            }
            return value;
        };
    
        var myDate = timestamp? new Date(timestamp): new Date();
    
        var year = myDate.getFullYear();
        var month = zero(myDate.getMonth() + 1);
        var day = zero(myDate.getDate());
    
        var hour = zero(myDate.getHours());
        var minite = zero(myDate.getMinutes());
        var second = zero(myDate.getSeconds());
    
        return formats.replace(/Y|m|d|H|i|s/ig, function (matches) {
            return ({
                Y: year,
                m: month,
                d: day,
                H: hour,
                i: minite,
                s: second
            })[matches];
        });
    },
    /**
     * 获取cookie
     * @param {*} t 
     * @returns 
     */
    getCookie:function(t){
        for(var i=document.cookie.split("; "),e=0;e<i.length;e++){
            var s=i[e].split("=");
            if(t==s[0])
            return s[1]
        }
        return null
    },
    /**
     * hex8转换为rgba的字符串格式
     * @returns 
     */
    hex8ToRgbaString:function(hex){
        if (hex.length < 9 || hex[0] != '#') return hex
        let r = parseInt(hex.slice(1, 3), 16)
        let g = parseInt(hex.slice(3, 5), 16)
        let b = parseInt(hex.slice(5, 7), 16)
        let a = parseInt(hex.slice(7, 9), 16)/255
        let res = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')'
        return res
    },
    /**
     * hex8转换为rgba对象格式
     * {
        "r": 218,
        "g": 12,
        "b": 12,
        "a": 1
    }
     * @returns 
     */
    hex8ToRgbaObject:function(hex){
        if (hex.length < 9 || hex[0] != '#') return hex
        let r = parseInt(hex.slice(1, 3), 16)
        let g = parseInt(hex.slice(3, 5), 16)
        let b = parseInt(hex.slice(5, 7), 16)
        let a = parseInt(hex.slice(7, 9), 16)/255
        return {
            r,g,b,a
        }
    },
    /**
     * 追加class样式，单个或数组
     * @param {*} element 
     * @param {*} classNames 
     * @returns 
     */
    addClasss: function (element, classNames){
        if(!(classNames instanceof Array))
        {
            classNames = [classNames];
        }
  
        classNames.forEach(function (name){
            element.className += ' ' + name;
        });
  
        return element;
  
    },
    /**
     * 删除指定名称或数组的class样式
     * @param {*} element 
     * @param {*} classNames 
     * @returns 
     */
    removeClasss: function (element, classNames){
        var curCalsss = element.className;
        if(!(classNames instanceof Array))
        {
            classNames = [classNames];
        }
  
        classNames.forEach(function (name){
            curCalsss = curCalsss.replace(name, '');
        });
        element.className = curCalsss;
        return element;
  
    },
    /**
     * 判断是否存在class，只支持单个
     * @param {*} element 
     * @param {*} className 
     * @returns 
     */
    hasClasss: function (element, className){
      var result = false;
      var curCalsss = element.className;
      if(curCalsss){
          curCalsss = curCalsss.split(" ");
          curCalsss.forEach(function(name){
              if(name==className){
                  result = true;
              }
          })
      }
      return result;
  
    }
}